"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Options for replacing tags using curly braces (`{` `}`).
 * Matches tags of the form `{variable}` in the text.
 * @example
 * // Example usage:
 * const text = 'Hello {variable}';
 * const result = replaceTags(text, { variable: 'world' }, CurlyBraces);
 * console.log(result); // Output: 'Hello world'
 */
var CurlyBraces = {
    name: "Curly Braces",
    openingTag: "{",
    closingTag: "}",
    tagPattern: /\{[^}]*\}/g,
    tagStartPattern: /^\{/,
    tagEndPattern: /\}$/,
};
exports.default = CurlyBraces;
